import { Injectable,EventEmitter,Output } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {Category} from "./category";
import {Query} from "./query";

@Injectable()
export class CategoryDataService {


  private dataUrl: string = "appData.json";
  //ss
  categories: Category[];
  topCategory: Category;
  currentQuery: Query;
  rootApp: any;
  listReady: Boolean = false;
  public userNav: EventEmitter<object>
  pageUrl: string="";
  pageHTML: string="";
  extraHtml: any = "extraHtml";

  test: string = "test";

  popups: Object[] = [
    {name: "NONE", id: 1},

  ];

  icons: Object[] = [
    {name: "doe-copyright-icon-apps.svg"},
  ];

  changeNav(){
    console.log('Change Nav Event..now emitting');

    this.userNav.emit({test:'ok'});
    console.log('emit done')

  }


  getData() {
    console.log("Service: getData")
    return this.http.get("./assets/appData.json")
      .map((res: Response) => res.json())
      .catch(this.handleError)
  }

  getData2() {
      console.log("Service: getData2")
      return this.http.get("./assets/html/page2.html")
          .map((res: Response) => res.text())
          .catch(this.handleError)

  }


  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    console.log("ERROR")
    console.error(error);
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }


  blah:string =null;

  constructor(private http: Http) {
    this.userNav = new EventEmitter();






  }

  pageData: string ='Arrr';


}



// WEBPACK FOOTER //
// ./src/app/category/category-data.service.ts